import { H4, Paragraph } from 'components/atoms/Text';

import { BlogCard as BlogCardComponent } from '../../atoms/Cards';
import { BlogCardDivider } from 'components/atoms/Dividers';
import { Button } from 'components/atoms/Buttons';
import Link from 'next/link';
import NextImage from "next/legacy/image";
import format from 'date-fns/format';
import styled from 'styled-components';

const BlogCard = ({ blog }) => {
  const image = blog?.thumbnailImage?.data?.attributes;
  return (
    <Link href={`/blog/${blog.slug}`} legacyBehavior>
      <BlogCardComponent>
        <NextImage
          src={image?.url}
          alt={image?.alternativeText}
          width={1920}
          height={1080}
          objectFit={'cover'}
        />
        <H4 $ellipsis>{blog.title}</H4>
        <Paragraph $ellipsis $padding="0" $lineHeight={0.8}>
          {blog.excerpt}
        </Paragraph>
        <BlogCardDivider />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Button $primary $padding="0.2rem 1.5rem">
            Read Now
          </Button>
          <span itemProp="datePublished">
            {format(
              blog.createdAt ? Date.parse(blog.createdAt) : new Date(),
              'MMMM do, yyyy'
            )}
          </span>
        </div>
      </BlogCardComponent>
    </Link>
  );
};

const BlogListWrapper = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  width: '100%',
  maxWidth: '1000px',
  margin: '0 auto',
  gap: '2rem',
  [`@media screen and (max-width: ${theme.breakpoints.sm.maxWidth})`]: {
    gridTemplateColumns: '1fr',
    maxWidth: '95%',
    justifyContent: 'center',
  },
}));

export default function BlogList({ blogs }) {
  return (
    <BlogListWrapper>
      {blogs.map((blog) => (
        <BlogCard key={blog.id} blog={blog.attributes} />
      ))}
    </BlogListWrapper>
  );
}
